/** True when animations may run: not reduced-motion, not the prerender crawler. */
export const motionOn = () =>
  typeof document !== 'undefined' && document.documentElement.classList.contains('motion');

/** Fine pointer (mouse/trackpad): gates hover-follow effects. */
export const finePointer = () =>
  typeof window !== 'undefined' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
